import { Link } from "react-router";

import { cn } from "@/lib/cn";

/**
 * Two-option switch at the top of Clinical configuration: the guided
 * sections (default) or the plain-text pack files editor.
 */
export function ConfigViewSwitch({
  projectId,
  active,
}: {
  projectId: string;
  active: "guided" | "files";
}) {
  const base = `/projects/${encodeURIComponent(projectId)}/config`;
  const options = [
    { id: "guided", label: "Guided", to: base },
    { id: "files", label: "Files editor", to: `${base}/files` },
  ] as const;
  return (
    <nav aria-label="Configuration view" className="mb-4">
      <div className="inline-flex rounded-md border border-border bg-card p-0.5 text-sm">
        {options.map((option) => (
          <Link
            key={option.id}
            to={option.to}
            aria-current={option.id === active ? "page" : undefined}
            className={cn(
              "rounded px-3 py-1 font-medium text-muted-foreground hover:text-foreground",
              option.id === active &&
                "bg-primary text-primary-foreground hover:text-primary-foreground",
            )}
          >
            {option.label}
          </Link>
        ))}
      </div>
    </nav>
  );
}
